export const NEW_JOINEE_DRAFT_SECTIONS = ["A", "B", "C", "D", "E"];

// Client only owns request/response wrapper shape. The server owns field
// sanitization and meaningful-draft validation.
export const newJoineeDraftMap = {
  A: { wrapperKey: "user" },
  B: { wrapperKey: "employmentHistory" },
  C: { wrapperKey: "qualifications" },
  D: { wrapperKey: "bankDetails" },
  E: { wrapperKey: "medicalInsurance" },
};

export const draftFormMap = {
  newJoinee: newJoineeDraftMap,
  selfDeclaration: {
    main: { wrapperKey: "selfDeclaration" },
  },
  epf: {
    main: { wrapperKey: "epf" },
  },
  form11: {
    main: { wrapperKey: "form11" },
  },
  formF: {
    main: { wrapperKey: "formF" },
  },
  formQ: {
    main: { wrapperKey: "formQ" },
  },
  nda: {
    main: { wrapperKey: "nda" },
  },
};
